import React from "react";

import { Button, Divider, Input, Row, Col, ConfigProvider } from "antd";

import "./ApprovalFlow.css";

function ApprovalFlow() {
  return (
    <div className="approval-flow">
      <Divider orientation="left">Bills between</Divider>
      <div className="bills">
        <Row align="center">
          <Col flex="50px">
            <div className="symbol-container">$</div>
          </Col>
          <Col flex="auto">
            <ConfigProvider
              theme={{
                token: {
                  borderRadius: 0,
                  colorBorder: "silver",
                },
              }}
            >
              <Input placeholder="0.00" />
            </ConfigProvider>
          </Col>
        </Row>
        <Row>
          <Col flex="40px">
            <hr />
          </Col>
        </Row>
        <Row align="center">
          <Col flex="50px">
            <div className="symbol-container">$</div>
          </Col>
          <Col flex="auto">
            <ConfigProvider
              theme={{
                token: {
                  borderRadius: 0,
                  colorBorder: "silver",
                },
              }}
            >
              <Input placeholder="0.00" />
            </ConfigProvider>
          </Col>
        </Row>
        <Row justify="end">
          <Col>
            <Button type="link" danger size="large">
              Delete Range
            </Button>
          </Col>
        </Row>
      </div>
      <div className="approvals">
        <Divider orientation="left">Authorized Approvers</Divider>
        <Row>
          <Col span={4}>
            <p>The first approver(s) is/are:</p>
          </Col>
          <Col span={20}>
            <ul className="emails-container">
              <li>Yamile Tullis (yamile@integrityoklahoma.com)</li>
              <li>Yamile Tullis (yamile@integrityoklahoma.com)</li>
              <li>Rhett Tullis (rhett@integrityokc.com)</li>
              <li>Maryluz Eslava (maryeslava2@gmail.com)</li>
            </ul>
          </Col>
        </Row>
      </div>
      <Row justify="center">
        <Col>
          <Button type="link" size="large">
            Add Another Step
          </Button>
        </Col>
      </Row>
    </div>
  );
}

export default ApprovalFlow;
